import React from "react";

import notfound from "../assets/images/notfound.svg";

const NotFound = () => {
  return (
    <div className="w-full  h-screen flex justify-center items-center  bg-warning-20">
      <div className="flex flex-col justify-center items-center bg-neutral-00 p-9 rounded-v-4xl">
        <img src={notfound} alt="not-found vector"></img>
        <h1 className="text-title-xl-semibold my-9">صفحه مورد نظر در دسترس نمی‌باشد!</h1>
        <p className="text-center">
          متاسفانه صفحه مورد نظر شما پیدا نشد،
          <br />
          برای پیدا کردن مسیر درست میتوانید سری به صفحه اول ونداپرداخت بزنید
        </p>
      </div>
    </div>
  );
};

export default NotFound;
